import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  borderedBox: {
    backgroundColor: '#FFFFFF',
    width: '100%',
    padding: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      padding: '1rem'
    }
  },
  headerTitle: {
    width: '100%',
    padding: '2.5rem 1.5rem',
    borderRadius: '1rem',
    backgroundColor: '#000000',
    color: '#FFFFFF',
    [theme.breakpoints.down('sm')]: {
      padding: '1.5rem 1rem'
    }
  },
  headerImage: {
    borderStyle: 'solid',
    borderWidth: '1px 4px 4px 1px',
    borderRadius: '1rem',
    objectFit: 'cover',
    maxWidth: '9.5rem',
    minHeight: '100%',
    marginRight: '0.5rem',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '6.5rem'
    }
  },
  headerBox: {
    display: 'flex',
    flexDirection: 'row'
  },
  collectionBox: {
    minHeight: '100%'
  },
  itemBox: {
    display: 'flex',
    padding: '0.5rem',
    borderRadius: '1rem',
    backgroundColor: ({ bgColor }) => bgColor,
    alignItems: 'center'
  },
  itemText: {
    width: '100%'
  },
  headerUser: {
    fontWeight: 'bold',
    marginBottom: '0.5rem'
  },
  headerText: {
    fontWeight: 'normal'
  },
  headerGap: {
    marginBottom: '1rem'
  },
  itemGap: {
    marginBottom: '0.5rem'
  }
}));
